import {
  GeoLocationInput  
}  from 'src/services/graphql/Models';
import { Parsable } from 'src/shared/utility';

export default class GeoLocation implements GeoLocationInput, Parsable {
  lng: number;
  lat: number;
  
  constructor ( from: any ) { 
    from = from || {};
    this.lng = typeof from.lng === 'function' ? from.lng() : from.lng || 174.63055269999995;
    this.lat =  typeof from.lat === 'function' ? from.lat() : from.lat || -36.9448729;
  }
  parseAbsolute() {
    return {
      lng: this.lng,
      lat: this.lat
    };
  }
}


// WEBPACK FOOTER //
// ./src/stores/application/classes/GeoLocation.ts